import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { useLocation, useNavigate } from "react-router-dom";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import InputForm from "../../../Components/InputForm/InputForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import moment from "moment";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  getEngagementForRisk,
  getResponsiblePersonsDropdown,
  getRiskDataById,
  getRMStatusOptions,
  InsertUpdateRiskMitigation,
} from "../../../Helpers/API/APIEndPoints";
import notify from "../../../Helpers/ToastNotification";

const RiskMitigationEdit = () => {
  let navigate = useNavigate();
  let location: any = useLocation();
  const { EmployeeId, RoleId } = getContext();
  const [engagementOptions, setEngagementOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>();
  const [riskTitle, setRiskTitle] = useState<any>();
  const [riskDescription, setRiskDescription] = useState<any>();
  const [mitigationAction, setMitigationActions] = useState<any>();
  const [dueDate, setDueDate] = useState<any>(null);
  const [personsOptions, setPersonsOptions] = useState<any>([]);
  const [selectedPersons, setSelectedPersons] = useState<any>([]);
  const [statusOption, setStatusOptions] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>();
  const [remarks, setRemarks] = useState<any>();
  const [FormErrors, setFormErrors] = useState<any>({});
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isActive, setIsActive] = useState<boolean>(true);

  useEffect(() => {
    getEngagement();
    getStatusOPtions();
  }, []);

  useEffect(() => {
    if (location.state) {
     // console.log("state==>", location.state);
      showLoader();
      const getDataById = async () => {
        let obj = {
          Id: location.state ? location.state.id : 0,
        };
        const { data } = await APICall(getRiskDataById, "POST", obj);
       // console.log("edit data=>", data);
        if (data != null) {
          let eng = engagementOptions.find(
            (ele) => ele.value == data.engagementId
          );
          let status = statusOption.find((ele) => ele.value == data.status);

          let responsiblePersons = data.responsiblePersons
            .split(",")
            .map((person) => person.trim().toLowerCase());

          let matchedPersons = [];

          responsiblePersons.forEach((personLabel) => {
            let matchedPerson = personsOptions.find(
              (ele) => ele.label.toLowerCase() == personLabel
            );
            if (matchedPerson) {
              matchedPersons.push(matchedPerson);
            }
          });
          setSelectedPersons(matchedPersons);
          setSelectedEngagement(eng);
          setRiskTitle(data.riskTitle);
          setRiskDescription(data.riskDescription);
          setMitigationActions(data.mitigationActions);
          setDueDate(data.dueDate);
          setSelectedStatus(status);
          setRemarks(data.remark);

          hideLoader();
        }
      };
      getDataById();
      hideLoader();
    }
  }, [location.state, engagementOptions, statusOption, personsOptions]);

  useEffect(() => {
    getResponsiblePerson();
  }, [selectedEngagement]);

  const getStatusOPtions = async () => {
    let obj = {};
    const { data } = await APICall(getRMStatusOptions, "POST", obj);
   // console.log("status dd=>", data);
    if (data != null && data != undefined) {
      const custom = data.map((ele) => {
        return {
          value: ele.value,
          label: ele.label,
        };
      });
      setStatusOptions(custom);
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "selectedEngagement") {
     // console.log("engagement event =>", event);
      setSelectedEngagement(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["selectedEngagement_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["selectedEngagement_isEmpty"]: "Enagagement is mandatory field",
        }));
      }
    }

    if (apiFieldName === "dueDate") {
      let dates = moment(event).format(moment.HTML5_FMT.DATE);
      setDueDate(dates);

      if (dates && Object.keys(dates).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["dueDate_isEmpty"]: undefined,
        }));
      } else if (!dates || Object.keys(dates).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["dueDate_isEmpty"]: "Due date is mandatory",
        }));
      }
    }

    if (apiFieldName === "selectedPersons") {
     // console.log("persons event =>", event);
      setSelectedPersons(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["selectedPersons_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["selectedPersons_isEmpty"]: "Responsible person is mandatory field",
        }));
      }
    }

    if (apiFieldName === "status") {
      setSelectedStatus(event);
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "riskTitle") {
      setRiskTitle(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["riskTitle_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["riskTitle_isEmpty"]: "Risk Title is mandatory field",
        }));
      }
    }

    if (apiFieldName === "riskDescription") {
      setRiskDescription(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["riskDescription_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["riskDescription_isEmpty"]: "Risk description is mandatory field",
        }));
      }
    }

    if (apiFieldName === "mitigationAction") {
      setMitigationActions(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["mitigationAction_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["mitigationAction_isEmpty"]: "Mitigation actions is mandatory field",
        }));
      }
    }

    if (apiFieldName === "remarks") {
      setRemarks(event.target.value);
    }
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});

    if (
      selectedEngagement == null ||
      !selectedEngagement ||
      Object.keys(selectedEngagement).length === 0
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["selectedEngagement_isEmpty"]: "Engagement is mandatory field",
      }));
      FormErrors["selectedEngagement_isEmpty"] =
        "Engagement is mandatory field";
    }

    if (!dueDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["dueDate_isEmpty"]: "Due Date is mandatory field",
      }));
      FormErrors["dueDate_isEmpty"] = "Due Date is mandatory field";
    }

    if (!riskTitle) {
      setFormErrors((preState) => ({
        ...preState,
        ["riskTitle_isEmpty"]: "Risk Title is mandatory field",
      }));
      FormErrors["riskTitle_isEmpty"] = "Risk title is mandatory field";
    }

    if (!riskDescription || Object.keys(riskDescription).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["riskDescription_isEmpty"]: "Risk description is mandatory field",
      }));
      FormErrors["riskDescription_isEmpty"] =
        "Risk description is mandatory field";
    }

    if (!mitigationAction || Object.keys(mitigationAction).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["mitigationAction_isEmpty"]: "Mitigation actions is mandatory field",
      }));
      FormErrors["mitigationAction_isEmpty"] =
        "Mitigation actions is mandatory field";
    }

    if (!selectedPersons || Object.keys(selectedPersons).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["selectedPersons_isEmpty"]: "Responsible person is mandatory field",
      }));
      FormErrors["selectedPersons_isEmpty"] =
        "Responsible person is mandatory field";
    }
  };

  const ResetFunction = () => {
    setSelectedEngagement({});
    setRiskTitle("");
    setRiskDescription("");
    setMitigationActions("");
    setDueDate(null);
    setSelectedPersons([]);
    setSelectedStatus({});
    setFormErrors({});
  };

  const onClickFunction = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "submit") {
      await onSubmitValidation();

      const isEmpty = await Object.values(FormErrors).every(
        (x) => x === null || x === "" || x == undefined
      );

      if (isEmpty) {
        let personIds = selectedPersons
          .map((person: { value: string }) => person.value)
          .join(",");

        let obj = {
          Id: location?.state ? location?.state?.id : 0,
          EngagementId: selectedEngagement.value,
          RiskTitle: riskTitle,
          RiskDescription: riskDescription,
          MitigationActions: mitigationAction,
          DueDate: dueDate,
          ResponsiblePersons: personIds,
          Remark: location?.state?.id ? remarks : "",
          StatusId: location?.state?.id ? selectedStatus.value : 0,
          CreatedBy: EmployeeId,
        };
       // console.log("submit obj==>", obj);
        const { data } = await APICall(InsertUpdateRiskMitigation, "POST", obj);
       // console.log("data after submit==>", data);
        if (data.id != null && data.id != undefined) {
          notify(0, "Data save successfully");
          navigate(-1);
        } else {
          notify(1, "Something went wrong!!!");
        }
      }
    }

    if (apiFieldName == "reset") {
      await ResetFunction();
    }
  };

  const getEngagement = async () => {
    let obj = {};
    if (RoleId.includes(3)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 3,
      };
    } else if (RoleId.includes(8)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 8,
      };
    } else if (RoleId.includes(2)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 2,
      };
    }

    const { data } = await APICall(getEngagementForRisk, "POST", obj);
   // console.log("engagement dd =>", data);
    if (data != undefined || data != null) {
      let customArray = data.map((ele: any) => {
        return {
          value: ele.engagementId,
          label: ele.engagementName,
        };
      });
      setEngagementOptions(customArray);
    }
  };

  const getResponsiblePerson = async () => {
    let obj = {
      EngagementId: selectedEngagement.value,
    };

    const { data } = await APICall(getResponsiblePersonsDropdown, "POST", obj);

   // console.log("persons dd=>", data);
    if (data != null && data != undefined) {
      let customArray = data.map((ele: any) => {
        return {
          value: ele.employeeId,
          label: ele.responsiblePersons,
        };
      });
      setPersonsOptions(customArray);
    }
  };

  return (
    <>
      <Heading title={"Risk Mitigation"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={engagementOptions}
                placeholder="Select"
                isDisabled={
                  location.state && location.state.status !== "Not Started"
                    ? true
                    : false
                }
                value={selectedEngagement}
                onChange={(event) =>
                  selectOnChange(event, "selectedEngagement")
                }
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {FormErrors["selectedEngagement_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Risk <sup>*</sup>{" "}
              </label>
              <InputForm
                placeholder={"Enter Risk"}
                isDisabled={
                  location.state && location.state.status !== "Not Started"
                    ? true
                    : false
                }
                textArea={false}
                value={riskTitle}
                onChange={(event) => handleTextEvent(event, "riskTitle")}
              />
              <p style={{ color: "red" }}>{FormErrors["riskTitle_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group d-flex flex-column justify-content-between">
              <label>
                Due Date <sup>*</sup>{" "}
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Due date"
                  value={dueDate}
                  disabled={
                    location.state && location.state.status !== "Not Started"
                      ? true
                      : false
                  }
                  onChange={(event) => selectOnChange(event, "dueDate")}
                  inputFormat="dd/MM/yyyy"
                  //maxDate= {new Date()}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
                <p style={{ color: "red" }}>{FormErrors["dueDate_isEmpty"]}</p>
              </LocalizationProvider>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Responsible Person's <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={personsOptions}
                placeholder="Select"
                isDisabled={
                  location.state && location.state.status !== "Not Started"
                    ? true
                    : false
                }
                value={selectedPersons}
                onChange={(event) => selectOnChange(event, "selectedPersons")}
                isMulti={true}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {FormErrors["selectedPersons_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Description <sup>*</sup>{" "}
              </label>
              <InputForm
                placeholder={""}
                isDisabled={
                  location.state && location.state.status !== "Not Started"
                    ? true
                    : false
                }
                textArea={true}
                value={riskDescription}
                rows={3}
                //col ={2}
                onChange={(event) => handleTextEvent(event, "riskDescription")}
              />
              <p style={{ color: "red" }}>
                {FormErrors["riskDescription_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Mitigation Actions <sup>*</sup>{" "}
              </label>
              <InputForm
                placeholder={""}
                isDisabled={
                  location.state && location.state.status !== "Not Started"
                    ? true
                    : false
                }
                textArea={true}
                value={mitigationAction}
                rows={3}
                //col ={2}
                onChange={(event) => handleTextEvent(event, "mitigationAction")}
              />
              <p style={{ color: "red" }}>
                {FormErrors["mitigationAction_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-12">
            {location.state && location.state.id ? (
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                  disabled={location.state && location.state.id ? false : true}
                />
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button onClick={() => navigate(-1)} className="btn btn-reset">
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={(event) => onClickFunction(event, "reset")}
                  className="btn btn-reset"
                  disabled={
                    location.state && location.state.status == "Completed"
                      ? true
                      : false
                  }
                >
                  Reset
                </button>

                <button
                  onClick={(event) => onClickFunction(event, "submit")}
                  className="btn btn-submit"
                  disabled={
                    location.state && location.state.status == "Completed"
                      ? true
                      : false
                  }
                  //disabled={disabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiskMitigationEdit;
